import React, { useState } from 'react';
import { Dropdown, ButtonGroup, Fade } from 'react-bootstrap';
import { AiOutlineHome, AiOutlineUser } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import './NavBarDropdown.css';

export function NavBarDropdown() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => setIsOpen(prevState => !prevState);
  const closeDropdown = () => setIsOpen(false);

  return (
    <Dropdown
      as={ButtonGroup}
      drop="down"
      align="end"
      show={isOpen}
      onToggle={(nextShow) => setIsOpen(nextShow)}
      className="navbar-dropdown"
    >
      <Dropdown.Toggle
        variant="link"
        id="dropdown-custom"
        onClick={toggleDropdown}
        className="toggle-button"
        aria-label="Open navigation menu"
      >
        <div className={`hamburger-icon ${isOpen ? 'open' : ''}`}>
          <div className="line top"></div>
          <div className="line bottom"></div>
        </div>
      </Dropdown.Toggle>

      <Fade in={isOpen} mountOnEnter unmountOnExit>
        <Dropdown.Menu align="end" className="dropdown-menu-custom">
          <Dropdown.Item as={Link} to="/" className="dropdown-item-custom" onClick={closeDropdown}>
            <AiOutlineHome className="dropdown-icon" />
            <span className="dropdown-text">Home</span>
          </Dropdown.Item>
          <Dropdown.Item as={Link} to="/about" className="dropdown-item-custom" onClick={closeDropdown}>
            <AiOutlineUser className="dropdown-icon" />
            <span className="dropdown-text">About</span>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Fade>
    </Dropdown>
  );
}
